export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/indoor_lifestyle.b134efa.svg";